import { useState, useEffect, useRef } from "react"
import { Link, useLocation } from "react-router-dom"
import { BsArrowRightCircleFill, BsDatabaseAdd, BsFillPersonLinesFill } from "react-icons/bs"
import { AiFillCaretDown } from "react-icons/ai"
import { BiCog, BiLock, BiLogInCircle, BiLogOutCircle } from "react-icons/bi"
import { RiAccountBoxFill } from "react-icons/ri"
import classes from "./Sidebar.module.css"

import { HOME_URL } from "../../constants"
import { AuthService } from "../../services/auth"
import { UserContextEntity } from "../../entities/UserEntity"
import { MdDashboard } from "react-icons/md"
import { HiArrowCircleDown, HiOutlineClipboardList } from "react-icons/hi"
import { IconType } from "react-icons"
import { IoDocumentTextOutline } from "react-icons/io5"

import { FiCommand } from 'react-icons/fi'

interface SidebarProps {
    close?: boolean
    showSidebar: boolean
    setShowSidebar: (val: boolean) => void
    userEntity: UserContextEntity | null
    setUserEntity: (val: UserContextEntity | null) => void
    setShowLogin: (val: boolean) => void
    setShowChangePass: (val: boolean) => void
    version: { ui: string, server: string }
}

interface SidebarDataType {
    title: string
    icon: IconType
    arrow: IconType
    link: string | null
    role: string[]
    childrens: ({
        title: string
        icon: IconType
        link: string
        roles: string[]
    } | undefined)[]
}

function Sidebar(props: SidebarProps) {
    const { showSidebar, setShowSidebar, userEntity, setUserEntity, setShowLogin, setShowChangePass, version } = props

    // ========================================= SIDEBAR DATA =========================================  //
    const SidebarData: SidebarDataType[] = [
        {
            title: "Generate",
            icon: FiCommand,
            arrow: HiArrowCircleDown,
            link: "/serial",
            role: ["Superadmin", "Admin"],
            childrens: []
        },
        {
            title: "Master",
            icon: BsDatabaseAdd,
            arrow: HiArrowCircleDown,
            link: null,
            role: ["Superadmin"],
            childrens: [
                {
                    title: "Users",
                    icon: BsFillPersonLinesFill,
                    link: "/master/users",
                    roles: ["Superadmin"],
                },
            ],
        },
        {
            title: "Report",
            icon: HiOutlineClipboardList,
            arrow: HiArrowCircleDown,
            link: null,
            role: ["Admin", "Superadmin"],
            childrens: [
                {
                    title: "Report NetstatSerial",
                    icon: IoDocumentTextOutline,
                    link: "/report/serial",
                    roles: ["Admin", "Superadmin"],
                },
            ],
        },
    ]
    // ========================================= SIDEBAR DATA =========================================  //

    function showChangePass() {
        setShowChangePass(true)
    }

    const toggleSide = () => {
        setShowSidebar(!showSidebar)
    }

    function emptyFunction() { }

    const [dropdowns, setDropdowns] = useState(
        SidebarData.map((val, index) => ({ drop: false, index }))
    )

    const toggleDrop = (index: number) => {
        const newDropdowns = [...dropdowns]
        if (newDropdowns[index].drop === true) {
            newDropdowns[index].drop = false
        } else {
            newDropdowns.map((dropdown) => {
                dropdown.drop = false
                return null
            })
            newDropdowns[index].drop = true
        }
        setDropdowns(newDropdowns)
    }

    const location = useLocation()

    function clickLogin() {
        setUserEntity(null)
        setShowLogin(true)
    }

    function clickLogout() {
        setUserEntity(null)
        setShowLogin(false)
        AuthService.logout()
        window.location.href = HOME_URL
    }

    function closeMenu() {
        if (props.close) {
            setShowSidebar(false)
        }
    }
    closeMenu()

    const nameRef = useRef(null)
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const [settingOpen, setSettingOpen] = useState(false)

    useEffect(() => {
        function handleResize() {
            setScreenWidth(window.innerWidth)
        }
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    //hacky fix later
    useEffect(() => {
        if (showSidebar === false) {
            setSettingOpen(false)
        }
    }, [showSidebar])

    useEffect(() => { }, [nameRef])

    return <aside
        style={{
            width:
                screenWidth <= 1080
                    ? showSidebar
                        ? "100%"
                        : "100%"
                    : showSidebar
                        ? "19vw"
                        : "3vw",
            gridTemplateColumns:
                screenWidth <= 1080
                    ? showSidebar
                        ? "100%"
                        : "100%"
                    : showSidebar
                        ? "19vw"
                        : "3vw",
            gridTemplateRows:
                screenWidth <= 1080
                    ? "0"
                    : showSidebar
                        ? "1fr 3fr 15fr 1fr"
                        : "1fr 1fr 17fr 1fr",
            height:
                screenWidth <= 1080
                    ? showSidebar
                        ? "100%"
                        : "4vh"
                    : showSidebar
                        ? "100vh"
                        : "100vh",
        }}
        className={classes.sidebar}>
        <div
            className={classes.menu}
            onClick={toggleSide}
            style={{
                paddingLeft: screenWidth <= 1080 ? "94vw" : showSidebar ? "85%" : "25%",
                transition: "1s",
            }}>
            <AiFillCaretDown
                style={{
                    fontSize: "3vh",
                    transform: showSidebar ? "rotate(180deg)" : "rotate(0deg)",
                    display: screenWidth <= 1080 ? "block" : "none",
                    transition: "0.5s",
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "3px"
                }}
            />
            <BsArrowRightCircleFill
                style={{
                    fontSize: "1.75vw",
                    transform: showSidebar ? "rotate(180deg)" : "rotate(0deg)",
                    display: screenWidth <= 1080 ? "none" : "block",
                    transition: "0.5s",
                }}
            />
        </div>

        <div className={classes.activeUser}>
            <div className={classes.user}
                style={{
                    display: screenWidth <= 1080 ? (showSidebar ? "flex" : "none") : "flex",
                    marginLeft: '8px',
                    marginRight: '8px'
                }}>

                {/* PROFILE PICTURE */}
                <div id={classes.pict} style={{ marginRight: showSidebar ? '12px' : '0px' }}>
                    <RiAccountBoxFill
                        onClick={() => { userEntity != null ? clickLogout() : setShowLogin(true) }}
                        style={{
                            fontSize: screenWidth <= 1080 ? "8vh" : showSidebar ? "3.5vw" : "2.5em"
                        }}
                    />
                </div>

                {/* USERNAME AND ROLE */}
                <div style={{ display: showSidebar ? "flex" : "none" }} id={classes.name}>
                    <div className={classes.username}>
                        <div style={{ fontWeight: 'bolder', fontSize: 'max(18px, 2vh)' }}>
                            {`${userEntity != null ? userEntity.username : "General User"}`}
                        </div>
                    </div>
                    <div style={{ marginTop: '2px' }}></div>
                    <div className={classes.role} style={{ fontWeight: 'lighter', fontSize: 'max(12px, 1.5vh)' }}>
                        {`${userEntity != null ? userEntity.rolename : ''}`}
                    </div>
                </div>

                {/* LOGIN/SETTING */}
                {userEntity != null
                    ? (
                        <div style={{ display: showSidebar ? "flex" : "none", cursor: 'pointer' }} onClick={() => { setSettingOpen(!settingOpen) }}>
                            <BiCog style={{ fontSize: screenWidth <= 1080 ? "5vh" : "3.5vh" }} />
                        </div>
                    )
                    : (
                        <div style={{ display: showSidebar ? "flex" : "none", cursor: 'pointer' }} onClick={clickLogin}>
                            <BiLogInCircle style={{ fontSize: screenWidth <= 1080 ? "5vh" : "3.5vh" }} />
                        </div>
                    )}
            </div>

            {/*hacky, its what its*/}
            {showSidebar ? <hr style={{ marginTop: '8px', marginBottom: '8px', marginLeft: '12px', marginRight: '12px', border: '1px solid var(--secondary-color)' }}></hr> : ''}
        </div>

        {
            !settingOpen
                ? <div className={classes.contRow} style={{ overflow: 'auto', maxHeight: '75vh' }}>
                    {SidebarData.map((val, index) => {
                        const Icon = val.icon;
                        return val.link
                            ? <div key={`Main Menu${index}`} onClick={() => { (val.childrens == null && screenWidth <= 1080) ? setShowSidebar(!showSidebar) : emptyFunction() }}>
                                <Link
                                    to={val.link}
                                    onClick={() => setShowSidebar(false)}
                                    className={classes.row}
                                    style={{
                                        display: screenWidth <= 1080
                                            ? showSidebar
                                                ? (val.role.includes(userEntity?.rolename ?? '') || val.role.length == 0 ? "flex" : "none")
                                                : (val.role.includes(userEntity?.rolename ?? '') || val.role.length == 0 ? "none" : "none")
                                            : showSidebar
                                                ? (val.role.includes(userEntity?.rolename ?? '') || val.role.length == 0 ? "grid" : "none")
                                                : (val.role.includes(userEntity?.rolename ?? '') || val.role.length == 0 ? "flex" : "none")
                                        ,
                                        width: screenWidth <= 1080 ? '80vw' : '100%'
                                    }}
                                >
                                    <div id={classes.icon} onClick={() => toggleDrop(index)}>
                                        <Icon
                                            style={{ fontSize: screenWidth <= 1080 ? "2em" : "1.5vw" }}
                                        />
                                        {screenWidth > 1080 && !showSidebar ? (
                                            <span className={classes.tooltiptext}>{val.title}</span>
                                        ) : null}
                                    </div>

                                    <div
                                        style={{ display: showSidebar ? "flex" : "none" }}
                                        id={classes.title}
                                        onClick={() => toggleDrop(index)}>
                                        {val.title}
                                    </div>

                                    {(screenWidth <= 1080 && showSidebar && <div style={{ flex: "20%" }}>&nbsp;</div>)}
                                </Link>
                                <div style={dropdowns[index].drop && screenWidth <= 1080 ? { display: 'grid', gridTemplateColumns: 'auto auto' } : {}}>
                                    {val.childrens &&
                                        val.childrens
                                            ?.filter((child) =>
                                                child != null &&
                                                child.roles !== null &&
                                                child.roles.find((x: string) => x.toLowerCase() === userEntity?.rolename.toLowerCase()) !== null
                                            )
                                            .map((child, subIndex: number) => {
                                                if (child == null) { return <></> }
                                                return <div key={`${val.title}-${subIndex}`}
                                                    style={
                                                        screenWidth <= 1080 ? {
                                                            marginTop: '16px',
                                                            marginBottom: '16px'
                                                        } : {}
                                                    }>
                                                    {((screenWidth <= 1080 && !showSidebar))
                                                        ? ''
                                                        : <Link to={child.link} className={classes.subRow}
                                                            style={{
                                                                paddingLeft: showSidebar ? "3.2vw" : "0",
                                                                display: dropdowns[index].drop || location.pathname.toLowerCase().includes(val.title.toLowerCase()) ? "flex" : "none",
                                                                justifyContent: showSidebar ? 'start' : 'center',
                                                                backgroundColor: location.pathname === child.link ? "var(--secondary-color)" : "transparent",
                                                                color: location.pathname === child.link ? "var(--header-color)" : "white",
                                                                fontWeight: location.pathname === child.link ? "bold" : "normal",
                                                                borderLeft: location.pathname === child.link ? "4px solid var(--primary-color)" : "none",
                                                            }}
                                                            onClick={(screenWidth <= 1080) ? () => toggleSide() : () => emptyFunction()}>
                                                            <div id={classes.icon}>
                                                                {child.icon({})}
                                                                {
                                                                    showSidebar ? '' : (<span className={classes.tooltiptext}>
                                                                        {child.title}
                                                                    </span>)
                                                                }
                                                            </div>
                                                            <div
                                                                style={{ display: showSidebar ? "block" : "none" }}
                                                                id={classes.title}>
                                                                {child.title}
                                                            </div>
                                                        </Link>
                                                    }
                                                </div>
                                            })}
                                </div>
                                {showSidebar ? <hr style={{ marginTop: '8px', marginBottom: '8px', border: '0.5px solid lightBlue' }}></hr> : ''}
                            </div>
                            : <div key={`Main Menu${index}`} onClick={() => { (val.childrens == null && screenWidth <= 1080) ? setShowSidebar(!showSidebar) : emptyFunction() }}>
                                <div
                                    className={classes.row}
                                    style={{
                                        display: screenWidth <= 1080
                                            ? showSidebar
                                                ? (val.role.includes(userEntity?.rolename ?? '') ? "flex" : "none")
                                                : (val.role.includes(userEntity?.rolename ?? '') ? "none" : "none")
                                            : showSidebar
                                                ? (val.role.includes(userEntity?.rolename ?? '') ? "grid" : "none")
                                                : (val.role.includes(userEntity?.rolename ?? '') ? "flex" : "none")
                                        ,
                                        width: screenWidth <= 1080 ? '80vw' : '100%',
                                    }}
                                >

                                    <div id={classes.icon} onClick={() => toggleDrop(index)}>
                                        <Icon
                                            style={{ fontSize: screenWidth <= 1080 ? "2em" : "1.5vw" }}
                                        />
                                        {screenWidth > 1080 && !showSidebar ? (
                                            <span className={classes.tooltiptext}>{val.title}</span>
                                        ) : null}
                                    </div>

                                    <div
                                        style={{ display: showSidebar ? "flex" : "none" }}
                                        id={classes.title}
                                        onClick={() => toggleDrop(index)}>
                                        {val.title}
                                    </div>

                                    {<div
                                        style={{
                                            display: showSidebar ? "grid" : "none",
                                            transform: dropdowns[index].drop
                                                ? "rotate(0deg)"
                                                : "rotate(90deg)",
                                        }}
                                        id={classes.arrow}
                                        onClick={() => toggleDrop(index)}>
                                        {'>'}
                                    </div>}
                                </div>
                                <div style={dropdowns[index].drop && screenWidth <= 1080 ? { display: 'grid', gridTemplateColumns: 'auto auto' } : {}}>
                                    {val.childrens &&
                                        val.childrens
                                            ?.filter((child) =>
                                                child != null &&
                                                child.roles !== null &&
                                                child.roles.find((x: string) => x.toLowerCase() === userEntity?.rolename.toLowerCase()) !== null
                                            )
                                            .map((child, subIndex: number) => {
                                                if (child == null) { return <></> }
                                                return <div key={`${val.title}-${subIndex}`}
                                                    style={
                                                        screenWidth <= 1080 ? {
                                                            marginTop: '16px',
                                                            marginBottom: '16px'
                                                        } : {}
                                                    }>
                                                    {((screenWidth <= 1080 && !showSidebar))
                                                        ? ''
                                                        : <Link to={child.link} className={classes.subRow} style={{
                                                            paddingLeft: showSidebar ? "3.2vw" : "0",
                                                            display: dropdowns[index].drop || location.pathname.toLowerCase().includes(val.title.toLowerCase()) ? "flex" : "none",
                                                            justifyContent: showSidebar ? 'start' : 'center',
                                                            backgroundColor: location.pathname === child.link ? "var(--secondary-color)" : "transparent",
                                                            color: location.pathname === child.link ? "var(--header-color)" : "white",
                                                            fontWeight: location.pathname === child.link ? "bold" : "normal",
                                                            borderLeft: location.pathname === child.link ? "4px solid var(--primary-color)" : "none",
                                                        }}
                                                            onClick={(screenWidth <= 1080) ? () => toggleSide() : () => emptyFunction()}>
                                                            <div id={classes.icon}>
                                                                {child.icon({})}
                                                                {
                                                                    showSidebar ? '' : (<span className={classes.tooltiptext}>
                                                                        {child.title}
                                                                    </span>)
                                                                }
                                                            </div>
                                                            <div
                                                                style={{ display: showSidebar ? "block" : "none" }}
                                                                id={classes.title}>
                                                                {child.title}
                                                            </div>
                                                        </Link>
                                                    }
                                                </div>
                                            })}
                                </div>
                                {showSidebar && val.role.includes(userEntity?.rolename ?? '') ? <hr style={{ marginTop: '8px', marginBottom: '8px', border: '0.5px solid lightBlue' }}></hr> : ''}
                            </div>
                    })}
                </div>
                : userEntity != null
                    ? <div className={classes.contRow} style={{ overflow: 'auto', maxHeight: '75vh' }}>
                        <div onClick={() => { setShowSidebar(!showSidebar); showChangePass() }}>
                            <div className={classes.row}
                                style={{
                                    display: screenWidth <= 1080
                                        ? showSidebar
                                            ? "flex"
                                            : "none"
                                        : showSidebar
                                            ? "grid"
                                            : "flex"
                                    ,
                                    width: screenWidth <= 1080 ? '80vw' : '100%',
                                }}>
                                <div id={classes.icon}>
                                    <BiLock
                                        style={{ fontSize: screenWidth <= 1080 ? "5vh" : "3.5vh" }}
                                    />
                                </div>

                                <div style={{ display: showSidebar ? "flex" : "none" }} id={classes.title}>
                                    Change Password
                                </div>
                            </div>
                            {showSidebar ? <hr style={{ marginTop: '8px', marginBottom: '8px', border: '0.5px solid lightBlue' }}></hr> : ''}
                        </div>
                        <div onClick={clickLogout}>
                            <div className={classes.row}
                                style={{
                                    display: screenWidth <= 1080
                                        ? showSidebar
                                            ? "flex"
                                            : "none"
                                        : showSidebar
                                            ? "grid"
                                            : "flex"
                                    ,
                                    width: screenWidth <= 1080 ? '80vw' : '100%',
                                }}>
                                <div id={classes.icon}>
                                    <BiLogOutCircle
                                        style={{ fontSize: screenWidth <= 1080 ? "5vh" : "3.5vh" }}
                                    />
                                </div>

                                <div
                                    style={{ display: showSidebar ? "flex" : "none" }}
                                    id={classes.title}>
                                    Logout
                                </div>
                            </div>
                            {showSidebar ? <hr style={{ marginTop: '8px', marginBottom: '8px', border: '0.5px solid lightBlue' }}></hr> : ''}
                        </div>
                    </div>
                    : ''
        }

        <div
            style={{
                display:
                    screenWidth <= 1080
                        ? showSidebar
                            ? "flex"
                            : "none"
                        : showSidebar
                            ? "none"
                            : "none",
                height: screenWidth <= 1080 ? "100vh" : "0px",
                borderTop: dropdowns[dropdowns.length - 1].drop ? "2px solid var(--secondary-color)" : "0px solid var(--secondary-color)",
                margin: "0vh 3vw"
            }}
            onClick={() => { setShowSidebar(!showSidebar) }}>
        </div>
        <div
            className={classes.version}
            style={{
                display: showSidebar ? "flex" : "none",
            }}>
            <div className={classes.info}>
                <label>UI Version: </label>
                <div>{version && version.ui ? version.ui : "Undefined"}</div>
            </div>
            <div className={classes.info}>
                <label>Server Version: </label>
                <div>
                    {version && version.server ? version.server : "Undefined"}
                </div>
            </div>
        </div>
    </aside>
}

export default Sidebar
